import { Fragment } from "react";
import { BalanceItem } from "components/UI/molecules";
import { BalanceItemLabel } from "components/UI/atoms";
import { useGetGiftCardBalanceList } from "./utils/useGetGiftCardBalanceList";
import "./index.scss";

export const BalanceCheckList = () => {
  const { giftCardBalanceListByLetter } = useGetGiftCardBalanceList();

  if (!giftCardBalanceListByLetter) {
    return null;
  }

  return Object.keys(giftCardBalanceListByLetter).map((letter) => {
    const balances = giftCardBalanceListByLetter[letter];

    return (
      <Fragment key={letter}>
        <BalanceItemLabel label={letter} />
        <div className="balance-items-container">
          {balances.map((balance) => (
            <BalanceItem
              name={balance.product_source.name}
              slug={balance.product_source.slug}
              phone={balance.product_source.phone}
              key={balance.product_source.id}
            />
          ))}
        </div>
      </Fragment>
    );
  });
};
